<div class="business-pin-bg">
	<div *ngIf="!isMobile">
		<app-pin-get-started-desktop>
		</app-pin-get-started-desktop>
	</div>
	<div *ngIf="isMobile">
		<app-pin-get-started-mobile>
		</app-pin-get-started-mobile>
	</div>
</div>

